module.exports = __webpack_public_path__ + "static/media/star_outline_white_36dp.d64bea59.svg";